export const normalizeDialCode = (value) => {
  if (value === null || value === undefined) return null;
  const normalized = String(value).replace(/[^\d]/g, "").trim();
  return normalized || null;
};

export const normalizeCountryCode = (value) => normalizeDialCode(value) ?? "";

export const parseDialCodes = (value) => {
  if (value === null || value === undefined) return [];

  const dialCodes = String(value)
    .split(/[,/;|]+/)
    .map((item) => normalizeDialCode(item))
    .filter(Boolean);

  return [...new Set(dialCodes)];
};
